import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../global-constants";
import { PlatformService } from "./platform/platform.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private API_URL: string;
  private API_SHARED_URL: string;

  constructor(
    private httpClient: HttpClient,
    private platformService: PlatformService,
  ) {
    const host = this.platformService.getLocationHostname();
    const constantesGlobales: any = new GlobalConstants(host);
    this.API_URL = constantesGlobales.urlApi;
    this.API_SHARED_URL = constantesGlobales.urlSharedApi;
  }

  /**
   * Llamada a la API para solicitar el login de un usuario
   *
   * @param {string} mail - Email del usuario
   * @param {string} password - Contraseña del usuario
   * @returns
   */
  public sendLogin(mail: string, password: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json, text/javascript, */*; q=0.01",
    });
    const body = new HttpParams().set("email", mail).set("password", password);
    return this.httpClient.get<any>(this.API_URL + "/sendLogin", { headers: headers, params: body });
  }

  /**
   *  Llamada a la API para comprobar si el email ya está registrado
   * @param {string} mail - Email a comprobar
   * @returns
   */
  public checkMail(mail: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json, text/javascript, */*; q=0.01",
    });
    const body = new HttpParams().set("email", mail);
    return this.httpClient.get<any>(this.API_URL + "/checkMail", { headers: headers, params: body });
  }

  /**
   * Llamada a la API para crear un usuario nuevo
   *
   * @param {string} nombre - Nombre del usuario
   * @param {string} apellidos - Apellidos del usuario
   * @param {string} email - Email del usuario
   * @param {string} pass - Contraseña del usuario
   * @param {string} notifications - Notificaciones del usuario
   * @param {number} id_ambito - Id del ambito del usuario
   * @returns Observable<any> - Respuesta de la API
   */
  public newUser(nombre: string, apellidos: string, email: string, pass: string, id_ambito: number): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json, text/javascript, */*; q=0.01",
    });
    const body = new HttpParams().set("nombre", nombre).set("apellidos", apellidos).set("email", email).set("pass", pass).set("id_ambito", id_ambito);
    return this.httpClient.get<any>(this.API_URL + "/insertUser", { headers: headers, params: body });
  }

  /**
   * Llamada a la API para crear un usuario nuevo a través del login social de Google
   *
   * @param idToken - Token de usuario de Google
   * @returns Observable<any> - Respuesta de la API
   */

  public sendGoogleLogin(idToken: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json, text/javascript, */*; q=0.01",
    });
    const body = {
      idToken,
    };

    return this.httpClient.post<any>(this.API_SHARED_URL + "/social-login/login", body, { headers: headers });
  }
}
